module.exports = __webpack_public_path__ + "img/Turning.3655aaa5.svg";